import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const WorksheetRoutes: RouteBundle = {
  domain: 'notebook',
  routes: [{urlPattern: 'worksheets/:id', handler: EditorRoutes.worksheetEditor.bind(EditorRoutes)}],
};
